export const defaultDomains = ["lingoapp.com"];

export const defaultSubdomains = [
  "www",
  "www-test",
  "www.test",
  "www-staging",
  "www.staging",
  "local",
  "",
];

type SpaceIdentifier = {
  subdomain?: string;
  host?: string;
  identifier?: string;
};

export default function parseHostname(hostname: string): SpaceIdentifier {
  const components = hostname
      .replace(/https?:\/\//, "")
      .split("/")[0]
      .split(":")[0]
      .split("."),
    _subdomain = components.slice(0, -2).join("."),
    _host = components.slice(-2).join(".");

  const defaultDomains = ["lingoapp.com"],
    defaultSubdomains = ["www", "www-test", "www.test", "www-staging", "www.staging", "local", ""];

  const subdomain = defaultSubdomains.includes(_subdomain) ? null : _subdomain,
    host = defaultDomains.includes(_host) ? null : _host,
    identifier = [subdomain, host].filter(Boolean).join(".");

  return {
    subdomain,
    host,
    identifier: identifier.length ? identifier : null,
  };
}
